import React, { Component } from 'react'
import { compose } from 'recompose'

import { History as HistoryComp } from 'components/misc'
import { apiActions } from 'helpers/decorators/api'

const enhance = compose(apiActions({ loadOnMount: false }))

class History extends Component {
  render() {
    return <HistoryComp {...this.props} />
  }
}

export default enhance(History)
